const EventEmitter = require('events'); 
const emitter = new EventEmitter();

const Global = {
	User:{}
};

//正式服
exports.ApiHost = "https://v3.kzpipe.cn";
exports.WsHost = "wss://v3.kzpipe.cn";
exports.appId = "wx1c64822335d570b6";
//测试服
// exports.ApiHost = 'http://localhost:8080';
// exports.WsHost = "ws://localhost:8080";
// exports.appId = "wx1c64822335d570b6";

exports.Store = null;
exports.RoutePrefix = '';

exports.Version = "3.3.21-master";

exports.Global = Global;
exports.Emitter = emitter;

// 添加地图代理配置
const mapProxyConfig = {
    development: 'https://v3.kzpipe.cn/map-proxy',  // 本地开发环境
    test: 'https://v3.kzpipe.cn/map-proxy',  // 测试环境
    production: 'https://v3.kzpipe.cn/map-proxy'  // 生产环境
};
  
// 获取当前环境的地图代理URL
exports.getMapProxyUrl = () => {
    const env = process.env.NODE_ENV || 'development';
    return mapProxyConfig[env];
};